'use client';

import React from 'react';

type Callback<T> = (value: T) => void;
type DispatchWithCallback<T> = (value: React.SetStateAction<T>, callback?: Callback<T>) => void;

export const useStateCallback = <T extends unknown>(initialState: T | (() => T)): [T, DispatchWithCallback<T>] => {
  const [state, _setState] = React.useState(initialState);

  const callbackRef = React.useRef<Callback<T>[]>([]);

  const setState = React.useCallback((setStateAction: React.SetStateAction<T>, callback?: Callback<T>): void => {
    if (callback) {
      callbackRef.current.push(callback);
    }
    _setState(setStateAction);
  }, []);

  React.useEffect(() => {
    callbackRef.current.forEach(callback => callback(state));
    callbackRef.current = [];
  }, [state]);

  return [state, setState];
};
